import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  vehicleTypes: [],
  allVehicleTypes: [],
  totalPages: 0,
  totalRecords: 0,
  vehicleType: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_109: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_VehicleTypes(state, vehicleTypes) {
    state.vehicleTypes = vehicleTypes.items;
    state.totalPages = vehicleTypes.totalPages;
    state.totalRecords = vehicleTypes?.totalRecords ?? 0;
  },
  SET_AllVehicleTypes(state, vehicleTypes) {
    state.allVehicleTypes = vehicleTypes;
  },
  SET_VehicleType(state, vehicleType) {
    state.vehicleType = vehicleType;
  },
};
const actions = {
  errorVehicleType({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllVehicleTypes({ commit, dispatch, rootState }) {
    return apiClient
      .get('/VehicleTypes/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllVehicleTypes', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicleType', error);
      });
  },
  addVehicleType({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/VehicleTypes', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicleType', error);
      });
  },
  getVehicleType({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/VehicleTypes/ById?vehicleTypeId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_VehicleType', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicleType', error);
      });
  },
  editVehicleType({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/VehicleTypes/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicleType', error);
      });
  },
  deleteVehicleType({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/VehicleTypes/Remove?vehicleTypeId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicleType', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
